<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<h2 class="fm_title"><span class="bold">Also by the same author</span></h2>
<p class="hangp"><em class="italic">Hunting from Hampstead: The Story of Henry and Lucy Stedall and their Children</em> (Book Guild Publishing, 2002)</p>
<p class="hangp">A two-volume history of Mary Queen of Scots:</p>
<p class="hangp"><em class="italic">The Challenge to the Crown, Volume I: The Struggle for Influence in the Reign of Mary Queen of Scots 1542–1567</em> (Book Guild Publishing, 2012)</p>
<p class="hangp"><em class="italic">The Survival of the Crown, Volume II: The Return to Authority of the Scottish Crown Following Mary Queen of Scots’ Deposition from the Throne</em> (Book Guild Publishing, 2014)</p>
<p class="hangp"><em class="italic">Men of Substance: The London Livery Companies’ Reluctant Part in the Plantation of Ulster</em> (Austin Macauley Publishers, 2016)</p>
<p class="hangp"><em class="italic">Mary Queen of Scots’ Downfall: The Life and Murder of Henry, Lord Darnley</em> (Pen &amp; Sword Books Limited, 2017)</p>
<p class="hangp"><em class="italic">The Roots of Ireland’s Troubles</em> (Pen &amp; Sword Books Limited, 2019)</p>
<p class="hangp"><em class="italic">Elizabeth I’s Secret Lover: Robert Dudley, Earl of Leicester</em> (Pen &amp; Sword Books Limited, 2020)</p>
<p class="hangp1"><span class="bold">Website</span>: <span class="weblink"><a href="http://www.maryqueenofscots.net" target="_blank"><span class="underline">www.maryqueenofscots.net</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Author.vue?070e0cf2